import axios from "axios";

const defaultBaseUrl = process.env.NODE_ENV === 'production'
  ? 'https://core-api.fromyouflowers.com/'
  : 'https://localhost:5101/';

export default class HttpClient {
  constructor(baseUrl) {
    const url = baseUrl ?? defaultBaseUrl;
    this.api = axios.create({
      baseURL: url
    });
  }

  get(path, successCallback, errorCallback) {
    this.api.get(path)
      .then(function(success) {
        successCallback(success);
      })
      .catch(function(error) {
        errorCallback(error);
      })
      .then(function() {
        // always executed
      });
  }
}